import { ResourceType } from "./resources";
import { WorldState } from "./world";
import config from "../worldConfig";

const { PREY_REPRODUCE_RATE, PREY_REPRODUCE_MAX, PREY_ATTRITION_RATE } = config;

export class AnimalHandler {
  static doReproduce = (w: WorldState): WorldState => {
    return {
      ...w,
      resources: w.resources.map((r) => {
        if (r.resource !== ResourceType.ANIMAL_PREY) {
          return r;
        }

        //max Birth depends on world position
        //@TODO: add ground/climate type effects
        const maxBirth = PREY_REPRODUCE_MAX;
        const birthNum = Math.min(
          Math.floor(r.quantity * PREY_REPRODUCE_RATE),
          maxBirth
        );

        const attritionNum = Math.floor(
          (r.quantity + birthNum) * (1 - PREY_ATTRITION_RATE)
        );

        const newQuantity = r.quantity + birthNum - attritionNum;

        return {
          ...r,
          quantity: newQuantity,
        };
      }),
    };
  };
}
